import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomModal, InputText } from '../../../../../components'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'

const INITIAL_STATE = {
  selectedMotivo: {
    name: '',
    tp_id: null,
  },
  loading: false,
  errorMessage: null,
}

const ModalCadastroMotivoBloqueioPosicaoEstoque = ({
  visible,
  onModalSave,
  onError,
  onModalClose,
  tpId,
  selectedMotivo,
}) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (visible) {
      if (selectedMotivo) {
        setState(prevState => ({ ...prevState, selectedMotivo: selectedMotivo }))
      } else {
        setState({
          ...INITIAL_STATE,
          selectedMotivo: { ...INITIAL_STATE.selectedMotivo, tp_id: tpId },
        })
      }
    }
  }, [visible])

  useEffect(() => {
    if (state.loading) {
      if (state.selectedMotivo.id) {
        EstoqueHttp.updateMotivosBloqueioPosicaoEstoque(tpId, state.selectedMotivo)
          .then(res => {
            onModalSave(res)
            setState({
              ...INITIAL_STATE,
              selectedMotivo: { ...INITIAL_STATE.selectedMotivo, tp_id: tpId },
            })
          })
          .catch(err => {
            onError(err)
            setState(prevState => ({ ...prevState, loading: false, errorMessage: err }))
          })
      } else {
        EstoqueHttp.saveMotivosBloqueioPosicaoEstoque(tpId, state.selectedMotivo)
          .then(res => {
            onModalSave(res)
            setState({
              ...INITIAL_STATE,
              selectedMotivo: { ...INITIAL_STATE.selectedMotivo, tp_id: tpId },
            })
          })
          .catch(err => {
            onError(err)
            setState(prevState => ({ ...prevState, loading: false, errorMessage: err }))
          })
      }
    }
  }, [state.loading])

  // Events
  const onBtnSalvarClicked = () => {
    const { name } = state.selectedMotivo
    if (name.trim().length === 0) {
      onError('O nome do motivo é obrigatório')
    } else {
      setState({ ...state, loading: true })
    }
  }

  // Render
  return (
    <CustomModal
      header={state.id ? 'Editar Motivo' : 'Novo Motivo'}
      isVisible={visible}
      onClose={onModalClose}
      width={450}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}>(*) Campo Obrigatório</span>
        </div>
        <div className="p-col-12">
          <InputText
            label="Nome* :"
            marginTop={10}
            value={state.selectedMotivo.name}
            onChange={name =>
              setState({ ...state, selectedMotivo: { ...state.selectedMotivo, name: name } })
            }
          />
        </div>
        <div className="p-col-12" style={{ paddingTop: 32, textAlign: 'end' }}>
          <Btn disabled={state.id} isLoading={state.loading} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(ModalCadastroMotivoBloqueioPosicaoEstoque)
